/*
	API関連のメソッド
 */
import axios from '../../libs/axios/axios'

const API_URL = '/sol_api/'

// キャッシュするかどうか
const USE_CACHE = false

// キャッシュを保存
function setCache (name, data) {
	// Safariのプライベートモードだとエラーになってしまうのを回避
	try {
		sessionStorage.setItem(name, JSON.stringify(data))
	} catch (err) {
		console.error(err);
	}
}

// キャッシュを取り出す
function getCache (name) {
	const cache = sessionStorage.getItem(name)
	return cache ? JSON.parse(cache) : null
}

// 会員医療機関
function institutions (params) {
	return axios.get(`${API_URL}institutions/index/`, {params}).then(response => {
		return Promise.resolve(response.data.data)
	})
}

// 会員医療機関 マスタ
[
	'services', // 診療科目
	'servicedevs', // 診療科目（大）
	'vaccinations', // 予防接種
	'cancer', // がん検診
	'keywords', // キーワード
	'distincts', // 地域
].forEach(name => {
	institutions[name] = () => {
		const cache = getCache(`institutions.${name}`)
		if (USE_CACHE && cache) {
			return Promise.resolve(cache)
		}
		return axios.get(`${API_URL}institutions/${name}/`).then(response => {
			setCache(`institutions.${name}`, response.data.data)
			return Promise.resolve(response.data.data)
		})
	}
})

// 休日当番医
function holidays (params) {
	return axios.get(`${API_URL}holidays/index/`, {params}).then(response => {
		return Promise.resolve(response.data.data)
	})
}

// 医師会ニュース
function pages (params) {
	return axios.get(`${API_URL}page/`, {params}).then(response => {
		return Promise.resolve(response.data)
	})
}

export default {institutions, holidays, pages}
